import { useEffect, useState } from "react";
import { NextPage } from "next";
import { useRouter } from "next/router";
import { useUserProfile } from "@providers/profile";
import Loading from "@components/ui/loading";

const VerifyUser: NextPage = () => {
  const { setIsLoginOpen, setVerification } = useUserProfile();
  const { query, push, isReady } = useRouter();
  const [loading, setLoading] = useState(true);
  const code = query.token as string;
  const email = query.email as string;

  useEffect(() => {
    if (!isReady) return;

    setVerification({ email, code });
    if (code && email) setIsLoginOpen(true);

    setLoading(false);
  }, [isReady]);

  useEffect(() => {
    // Trigger page redirect
    if (!loading) push("/");
  }, [loading]);

  return (
    <>
      <Loading visible={true} />
    </>
  );
};

export default VerifyUser;
